import React, { useState, useEffect } from "react";
import { NAIL_IMAGES, INTERIOR, BRAND } from "../mock/mock";
import { Instagram } from "lucide-react";
import { getInstagramFeed, mediaSrc } from "../lib/api";

const FALLBACK = [NAIL_IMAGES[0], NAIL_IMAGES[2], NAIL_IMAGES[4], INTERIOR.hairspa, NAIL_IMAGES[6], NAIL_IMAGES[9]].map((src, i) => ({ id: "f" + i, image_url: src, media_type: "IMAGE", permalink: BRAND.instagram }));

export default function InstagramFeed() {
  const [items, setItems] = useState(FALLBACK);
  useEffect(() => {
    getInstagramFeed(12)
      .then((res) => { if (res && res.data && res.data.length) setItems(res.data); })
      .catch((e) => { if (process.env.NODE_ENV !== "production") console.error("IG feed failed:", e); });
  }, []);

  const disp = (m) => mediaSrc(m.media_type === "VIDEO" ? (m.thumbnail_url || m.image_url) : m.image_url);

  return (
    <section className="py-24 md:py-32 bg-viimii-2">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="reveal flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <p className="section-line text-gold mb-4">Follow Us</p>
            <h2 className="font-display text-4xl md:text-5xl font-medium leading-tight">
              Our Instagram <span className="gold-gradient-text italic">feed.</span>
            </h2>
          </div>
          <a href={BRAND.instagram} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 px-6 py-3 rounded-full text-black font-medium transition-transform hover:scale-105" style={{ background: "var(--viimii-gold)" }}>
            <Instagram size={17} /> Follow {BRAND.instagramHandle}
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {items.slice(0, 12).map((m) => (
            <a key={m.id} href={m.permalink || BRAND.instagram} target="_blank" rel="noreferrer" className="group relative aspect-square overflow-hidden rounded-2xl border hairline">
              <img src={disp(m)} alt={m.caption || "VIIMII Instagram"} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" loading="lazy" />
              <div className="absolute inset-0 grid place-items-center bg-black/0 group-hover:bg-black/45 transition-colors duration-300">
                <Instagram size={22} className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>
            </a>
          ))}
        </div>
        <p className="text-center text-xs text-cream/45 mt-6">Follow {BRAND.instagramHandle} for the latest reels, nail art & trends.</p>
      </div>
    </section>
  );
}
